import {PaymentMethodOption} from '@/app/main/paymentLink/v2/pages/paymentLinkV2/components/PaymentLinkV2Valid/components/PaymentMethodsSelector/models/types';

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

export const PAYMENT_METHODS: PaymentMethodOption[] = [
  {
    id: 'applepay',
    label: 'Apple Pay',
    iconSrc: '/assets/icons/apple_pay.svg',
    selectedIconSrc: '/assets/icons/apple_pay.svg',
    visible: isIOS,
  },
  {
    id: 'googlepay',
    label: 'Google Pay',
    iconSrc: '/assets/icons/google_pay.svg',
    selectedIconSrc: '/assets/icons/google_pay.svg',
    visible: !isIOS,
  },
  {
    id: 'card',
    label: 'Card',
    iconSrc: '/assets/icons/card_pay.svg',
    selectedIconSrc: '/assets/icons/card_pay_selected.svg',
    visible: true,
  },
] as const;
